export enum TaskType {
	Task = 1,
	NotificationTask = 2,
	TimerStepTask = 3,
	RevisionFlow = 4,
	RevisionTaskRestart = 5,
	TrainingAppExaminationTask = 6
}